import formats from '../../api/formats'
import AssistClasses from '../assist/AssistClasses.js'
import DocAbstract from './DocAbstract.js'

class Strategy extends DocAbstract.Strategy {
  getTypeCode () {
    return 'DRIVER_LIC_RF'
  }
  getTypeName () {
    return 'Водительское удостоверение'
  }
  createModel () {
    var model = new Model()
    return model
  }
  createDefaultModel (individual) {
    return Object.assign(this.createModel(),
      {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        birthday: individual.birthday
      })
  }
  updateSteps (scheme) {
    const ruleSerNum = (v) => !v || /^\d{2}\s[А-ЯЁ0-9]{2}\s\d{6}$/.test(v) || 'Неверный формат - [78 04 123456]'
    const ruleNameRu = (v) => !v || formats.isNameRu(v, 60) || 'Допустимы русские буквы'

    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Фамилия',
            name: 'surname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Имя',
            name: 'firstname',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отчество',
            name: 'patronymic',
            rules: Array.of(ruleNameRu),
            grow: true,
            size: {sm8: true, xs6: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата рождения',
            name: 'birthday',
            grow: true,
            size: {sm6: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место рождения',
            name: 'birthplace',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Дата выдачи',
            name: 'issued',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-date-field',
            label: 'Действительно до',
            name: 'validTo',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Подразделение',
            name: 'issuer',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Номер удостоверения',
            name: 'number',
            rules: Array.of(ruleSerNum),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Место жительства',
            name: 'address',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Категории, подкатегории транспортных средств',
            name: 'category',
            grow: true,
            size: {sm12: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    return `${model['number'] ? model['number'] : '-'}`
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    return formats.createComp(`
      <div>
      <div>Номер удостоверения:<b> ${model['number'] ? model['number'] : '-'}</b></div>
      <div>Дата выдачи:<b> ${model['issued'] ? formats.formatDate(model['issued']) : '-'}</b></div>
      <div>Действительно до:<b> ${model['validTo'] ? formats.formatDate(model['validTo']) : '-'}</b></div>
      </div>`)
  }
}

class Model {
  constructor () {
    this.modelType = '102.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/people/DocDriverLicRF.js